import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { AuthenticationService } from '../../authentication/services/authentication.service';

@Injectable()
export class TokenInterceptor implements HttpInterceptor {
  private readonly _authenticationService = inject(AuthenticationService);

  private _token: string;

  constructor() {
    this._authenticationService.getToken$().subscribe((token: string) => {
      if (!token) {
        return;
      }
      this._token = token;
    });
  }

  intercept(
    request: HttpRequest<any>,
    next: HttpHandler,
  ): Observable<HttpEvent<any>> {
    if (request.headers.has('Authorization') || !this._token) {
      return next.handle(request);
    }

    const newRequest = request.clone({
      setHeaders: {
        Authorization: `Bearer ${this._token}`,
      },
    });

    return next.handle(newRequest);
  }
}
